module.exports = __webpack_public_path__ + "static/media/img34.d34d61ff.jpg";